import { Loader, Point, Sprite } from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import vars from '../vars';
import Actor from './Actor';

class Scarecrow extends Actor {
  constructor(parent) {
    super(parent);

    this.sprite = new Sprite(Loader.shared.resources['textures/OBSTACLE_13_TALL'].texture);
    this.parent.addChild(this.sprite);

    this.resize();

    this.frameHandler = () => { this.frame(); };
  }

  resize() {
    this.sprite.anchor = new Point(0.5, 1);
    this.sprite.position.y = vars.layout.FRAME_HEIGHT;
    this.sprite.position.x = 80;
  }

  startMoving() {
    ticker.add(this.frameHandler);
    setTimeout(() => {
      ticker.remove(this.frameHandler);
      this.sprite.destroy();
    }, 2000);
  }

  frame() {
    this.sprite.position.x -= state.foregroundSpeed * ticker.speed;
  }
}

export default Scarecrow;
